import VersionCheck from 'react-native-version-check';
import { BackHandler, Linking } from 'react-native';
import React, { useEffect, useState } from 'react';

import { Button } from '@components/Button';
import { firebase } from '@lib/firebase';
import { useTranslation } from '@providers/I18n';
import { Modal, ModalContentLayout } from '@components/Modal';

type UpdateNeededProp = {
  isNeeded: boolean;
  storeUrl: string;
  currentVersion: string;
  latestVersion: string;
};

export const AppUpdate: React.FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateNeeded, setUpdateNeeded] =
    useState<UpdateNeededProp | null>(null);

  const applyForceUpdate =
    firebase.getRemoteConfigBoolean('APPLY_FORCE_UPDATE');

  useEffect(() => {
    if (applyForceUpdate) {
      checkUpdate();
    }
  }, [applyForceUpdate]);

  const checkUpdate = async () => {
    try {
      const res = await VersionCheck.needUpdate();

      if (res && res.isNeeded) {
        setUpdateNeeded(res);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.log('error in force update', error);
    }
  };

  const getLatestVersion = () => {
    BackHandler.exitApp();
    if (updateNeeded && updateNeeded.storeUrl) {
      Linking.openURL(updateNeeded.storeUrl);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      showCloseButton={false}
      paperStyle={{ height: '30%' }}
      onRequestClose={() => undefined}>
      <ModalContentLayout
        title={t('appUpdate.updateRequired', {
          defaultValue: 'Update Required',
        })}
        subtitle={t('appUpdate.title', {
          defaultValue: 'Please update your app to continue',
        })}
        actions={[
          <Button variant="primary" onPress={getLatestVersion}>
            {t('appUpdate.getLatestButton', {
              defaultValue: 'Get Latest Version',
            })}
          </Button>,
        ]}
      />
    </Modal>
  );
};
